import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus_sleeping from '@devices/settings/device_settings/networks_gen_2_plus_sleeping.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPlusSmoke',
	friendly_name: 'Plus Smoke',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'smokeAlarm', 'lowBattery'],
			settings: [
				webhooks_gen_2,
				networks_gen_2_plus_sleeping,
				bluetooth_gen_2,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
